ele.uri = (function(){
	
	return {
		getAbsoluteScriptUrlFromLocation: function(loc) {
			return (loc.protocol + "//" + loc.host + loc.pathname).stripTags();
		},
		
		buildUrl: function(event, params = {}) {
			var url=this.getRootDirectory()+"index.cfm?event="+event;
			for (var property in params) {
				if (params[property] != null) url=url+"&"+property+"="+params[property];
			}
			return url;
		},
		
		//relocates with same arguments as buildUrl
		relocate: function(event, params = {}) {
			setTimeout(function(){window.location = ele.uri.buildUrl(event, params);},0);
		},

		getRootDirectory: function(){
			if (ele.config.directory) {
				return ele.config.directory + "/";
			} else {
				return "";
			}
		},

        //can use URLParams when IE11 support is dropped
	    getParameterByName: function(url, name) {
		    var regex = new RegExp("[\\?&]" + name.toLowerCase() + "=([^&#]*)"),
		    results = regex.exec(String(url).toLowerCase());
		    return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " ")).stripTags();
		},

        getHash: function(url = window.location.href) {
		    let hash = window.location.hash.substr(1);
		    if (hash) return decodeURIComponent(hash).stripTags();
		    return "";
        }
	}

})();